'use client';

import { useEffect } from 'react';
import ErrorBoundaryFallback from '@/components/ErrorBoundaryFallback';
import { reportBoundaryError } from '@/lib/reportBoundaryError';

export default function RootError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	useEffect(() => {
		reportBoundaryError(error, 'root');
	}, [error]);

	return <ErrorBoundaryFallback error={error} reset={reset} />;
}
